var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.label)?_c('label',{staticClass:"text-muted font-size-10"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('v-select',{attrs:{"value":_vm.value,"searchable":false,"options":_vm.options,"placeholder":_vm.placeholder,"loading":false},on:{"searchChanged":_vm.onSearched,"input":_vm.onSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }